import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { Subscription } from 'rxjs';
import { LocalizationService } from '../services/Localization.service';

@Directive({
  selector: '[mriIeKendoDateTimeFormat]'
})
export class KendoDateTimeFormatDirective implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  constructor(
    private dateTimePicker: DateTimePickerComponent,
    private localizationService: LocalizationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const sub = this.localizationService.dateTimeFormat$.subscribe(f => {
      this.dateTimePicker.format = f;
      this.cdr.markForCheck();
    });
    this.subscriptions.add(sub);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
